export const defaultSettings = {
  usesThemeStyles: true,
}

export const defaultBase = {
  column: 'A',
}